// extracted by mini-css-extract-plugin
export default {"tooltip":"Nz-z","arrow":"Oz-z"};